import { render } from "./IconOpenLot.vue?vue&type=template&id=da005170"
import script from "./IconOpenLot.vue?vue&type=script&lang=js"
export * from "./IconOpenLot.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__